import { styled } from "@mui/system";
import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const CustomImage = styled("img")(({ theme }) => ({
  width: "100%",
  border: `1px solid ${theme.palette.component.borderColor}`,
  borderRadius: "10px",
  marginTop: "20px",
  marginBottom: "20px",
  "@media (max-width: 960px)": {
    width: "100%",
  },
}));

function ImageContainer({ itemName, itemImage }) {
  const theme = useTheme();

  return (
    <div sx={{ display: "flex", justifyContent: "center" }}>
      {itemImage !== null ? (
        <CustomImage
          src={
            itemImage
          }
          alt={`${itemName} - Menu item at Zielona Chatka Restaurant`}
        />
      ) : (
        <Typography
          variant="subtitle1"
          sx={{
            width: "100%",
            textAlign: "center",
            overflowWrap: 'break-word',
            whiteSpace: 'normal',
            paddingTop: "33.2%",
            paddingBottom: "33.2%",
            marginTop: "20px",
            marginBottom: "20px",
            border: `1px solid ${theme.palette.component.borderColor}`,
            borderRadius: "10px",
            "@media (max-width: 960px)": {
              width: "100%",
            },
          }}
        >
          {itemName}
        </Typography>
      )}
    </div>
  );
}

export default ImageContainer;
